/** Flag carried by a relative record that may be a QR kiosk account. */
export interface QrAccountFlag {
    isQrSignupRelative?: boolean;
}

/** Null-safe check for a QR kiosk account (a resident's kiosk login, created and removed by staff). */
export const isQrAccount = (relative?: QrAccountFlag | null): boolean => relative?.isQrSignupRelative === true;
